import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './mooc-info.component.html',
  styleUrls: ['./mooc-info.component.scss']
})
export class NecMoocInfoComponent implements OnInit {
  moreInfoData: any[];

  constructor() {
  }

  ngOnInit() {
    this.moreInfoData = [{
      title: 'ç¬¬ä¸å±æ¤çä¸ä¸æè¯¾å¶ä½å¹è®­ç­',
      text: `3æ4~3æ5æ¥ï¼âç¬¬ä¸å±æ¤çä¸ä¸æè¯¾å¶ä½å¹è®­ç­âå¨ä¸æµ·äº¤éå¤§å­¦éµè¡æ ¡åºä¸¾è¡ï¼å¸å¼äºæ¥èªåå±±å»é¢ãæµæ±å¤§å­¦éå±ç¬¬ä¸å»é¢ãä»æµ
      å»é¢ãæåå»é¢ç­å½åæ°åå®¶é¡¶å°å»é¢çæ¤çé¨ä¸»ä»»åæ ¸å¿æå­¦ç®¡çäººååå ãéè¿çè®ºä¸å®è·µç»åãåç»ä½éªå¼æå­¦çæ¨¡å¼ï¼å¸®å©æ¯ä½åä¼äºº
      åè¿éææ¡æè¯¾æå­¦çè¿ç¨æå·§ï¼å¹¶è½ç¬ç«è¿è¡ç¸å³æè¯¾è¯¾ç¨çå¶ä½ã`,
      imageUrl: 'assets/images/common/home/mooc-info/mooc-joint-photo.png'
    }, {
      title: 'ç°åºç­¾å°',
      text: `ä¼è®®ä¼å§ï¼å¤§å®¶çº·çº·æåºææºï¼å©ç¨å½åé¦å®¶éè¿æè¯¾æ¹å¼è¿è¡æ¤çæè²é¢åæ¹é©çäº¬é¢â512èè¯æè²ç½âè¿è¡ç°åºç­¾å°ï¼ç´æ¥éè¿å¾®
      ä¿¡æ«æäºç»´ç çæ¹å¼ç­¾å°ï¼å³æ¹ä¾¿åå¿«æ·ã`,
      imageUrl: 'assets/images/common/home/mooc-info/offline-sign.png'
    }, {
      title: 'åå®¾è´è¾',
      text: `ä¼ä¸é¿æ±å­¦èç¹èææä¸æµ·äº¤éå¤§å­¦æè¯¾ç ç©¶é¢é¢é¿æ±å¿æææãå¶ä½æå½ç¬¬ä¸é¨æ¤çä¸ä¸æè¯¾ãå¸¸è§æ¢æ§ççå¥åº·ç®¡çãçä¸æµ·äº¤é
      å¤§å­¦æ¤çå­¦é¢é¢é¿ç« ééææãå»çä¿¡æ¯åè¡ä¸ä¸å®¶â512èè¯æè²ç½âåå§äººäº¬é¢è¡ä»½å¯æ»è£ç¼ªåºåµåçåå«å°±ãåºäºæè¯¾çæè²æå­¦æ¹é©ãã
      ãæ¤çæè¯¾çåå±ãããæ¤å£«ä¼ ç»å¹è®­æ¨¡å¼å­å¨çé®é¢ãä¸»é¢ä½äºå¼å¹è´è¾ã`,
      imageUrl: 'assets/images/common/home/mooc-info/guest-speak.png'
    }, {
      title: 'æå­¦äºå¨',
      text: `å¶ä½æå½ç¬¬ä¸é¨æ¤çä¸ä¸æè¯¾ãå¸¸è§æ¢æ§ççå¥åº·ç®¡çãå¹¶å¨å½å¤Courseraä¸çº¿è¿è¡çä¸æµ·äº¤éå¤§å­¦æ¤çå­¦é¢é¢é¿ç« ééææãä½ä¸º
      å½åé«æ ¡æè¯¾æ¨è¿å·¥ä½å¸¦å¤´äººä¸æµ·äº¤éå¤§å­¦æè¯¾æ¨è¿åè´è´£äººæè¯¾ç ç©¶é¢é¢é¿å©çä½å»ºæ³¢èå¸ãä¸æµ·äº¤éå¤§å­¦æè¯¾æ¨è¿åè´è´£äººæç¿èå¸ãéå
      åèå¸åå«ä»æ¤çç±»æè¯¾å¶ä½çç»éªåæå·§ãæè¯¾å¶ä½å·¥ä½åãPPTç¾åææ¯ãç¿»è½¬è¯¾å ç­æ¹é¢è¿è¡æè¯¾ï¼å¸¦é¢å­¦åå¶å®è¯¾ç¨éé¢ãè®¨è®ºæå­¦ç®
      æ ãå¶ä½æå­¦åå®¹ãè®¾è®¡ç¿»è½¬æå­¦æ¹æ¡ï¼è®©å­¦åå¯¹å¨çº¿è¯¾ç¨æäºå¨æ°è®¤è¯ï¼å¹¶ä¸å­¦åè¿è¡äºå¨è®¨è®ºã`,
      imageUrl: 'assets/images/common/home/mooc-info/teach-act.png'
    }, {
      title: 'ææºè¯¾å ',
      text: `å¨ææºè¯¾å äºå¨ç¯èï¼éå¯¹èå¸ä»¬çé®é¢ï¼å­¦åä»¬çº·çº·æ¿åºææºï¼å©ç¨ â512èè¯æè²ç½âçè¯¾å å©æï¼éè¿éæ©å¯¹éåABCDEç­éé¡¹
      å¿«éå°å¯¹èå¸çæé®è¿è¡åç­ï¼èå¸éè¿é¢è²åéé¡¹ä¸ç¼å°±å¯çåºåä¸ªéé¡¹çéæ©äººæ°ãå°ææºä½ä¸ºè¯¾å äºå¨çå©æï¼ææçæé«äºå­¦åçè¯¾å 
      äºå¨æ§ã`,
      imageUrl: 'assets/images/common/home/mooc-info/phone-class.png'
    }, {
      title: 'å½å¶ä½éª',
      text: `ç°åºä½éªæè¯¾å¶ä½ç¯èï¼è¯¾ç¨å½å¶åå¬å¸ä¸ä¸çåå¦å¸å¯¹å­¦åä»¬è¿è¡äºé¢é¨è¡¥å¦ãåååºå®ç­åå¤å·¥ä½ï¼å­¦åä»¬ä¹å©ç¨ç©ºé²æ¶é´æ¿åºæ
      æºçæä¸ä¸âå°è¯âãæçå­¦åNGäºå¾å¤æ¬¡ï¼çå®ä½éªäºä¸æå½âæ¼åâçä¸æãå½å¶å®æåï¼å­¦åä»¬çº·çº·æç§çå¿µã`,
      imageUrl: 'assets/images/common/home/mooc-info/expirence.png'
    }, {
      title: 'é¢å¥çå¿µ',
      text: `ç»è¿å¬å¸åå®¹å¶ä½å¢éç´§å¼ å¤çï¼åæ¬éè¦2å¤©çè¯¾ç¨å¶ä½æ¶é´åç¼©å°äº3ä¸ªå°æ¶åå®æã11ç»å­¦åä»¬ææå½å¶çè¯¾ç¨å¨é¢å¥ç¯èéä¸å±
      ç¤ºï¼å­¦åä»¬éè¿ä½¿ç¨â512èè¯æè²ç½âè¿è¡ç°åºæç¥¨çæ¹å¼ï¼å¿«éè¯éåºäºæä½³è®¾è®¡å¥ãæä½³ä½åå¥ãæä½³åæå¥ãæä½³æ´»è·å¥ãæä½³åä¸å¥ç­
      å¥é¡¹ãè·å¥å­¦åä¸é¢å¥èå¸æç§çå¿µã `,
      imageUrl: 'assets/images/common/home/mooc-info/awards.png'
    }, {
      title: 'ä½éªææ',
      text: `å¹è®­ç»ææ¶å­¦åä»¬çº·çº·è¡¨ç¤ºè¿æ¬¡äº¬é¢ä¸¾åçç¬¬ä¸å±æè¯¾å¶ä½å¹è®­ç­å¾åæ¶ä¹å¾å¿è¦ï¼éè¿è¿æ¬¡å¹è®­è®©å¤§å®¶äºè§£äºå¾å¤å³äºæè¯¾å¶ä½ç
      æ¹æ³åæ³¨æäºé¡¹ï¼çº æ­£äºå¤§å®¶å¯¹æè¯¾çè®¤è¯è¯¯åºï¼æ·±åäºå¯¹æè¯¾æå­¦çè®¤è¯ãä½éªå°æè¯¾æå­¦çä¼å¿åï¼å­¦åä»¬è¡¨ç¤ºäº¬é¢â512èè¯æè²ç½âä½ä¸º
      æ¤çæè¯¾æè²è¡ä¸çé¢å¤´ç¾ï¼å¸æè½ç»ç»æ´å¤å³äºæ¤çæè¯¾çå¹è®­æ´»å¨ï¼å¸®å©å¤§å®¶ä¸èµ·ææ¤çæè²æ¨åä¸ä¸ªæ°é«åº¦ã`,
      imageUrl: 'assets/images/common/home/mooc-info/feels.png'
    }];
  }
}
